<template>
  <div class="filter">
    <div class="filterContainer">
      <div class="mr10">
        <span class="tar title">重定向自：</span>
        <a-input
          v-model:value="postParams.fromUrl"
          style="width: 150px;"
          placeholder="请输入"
        />
      </div>
      <div class="mr10">
        <span class="tar title">重定向至：</span>
        <a-input
          v-model:value="postParams.toUrl"
          style="width: 150px;"
          placeholder="请输入"
        />
      </div>
      <div class="mr20">
        <span class="tar title">场景：</span>
        <a-input
          v-model:value="postParams.scene"
          style="width: 150px;"
          placeholder="请输入"
        />
      </div>
      <div class="mr20">
        <span class="tar title">状态码：</span>
        <a-input
          v-model:value="postParams.statusCode"
          style="width: 150px;"
          placeholder="请输入"
        />
      </div>
      <div>
        <a-button class="mr10" @click="() => resetParams()">重置</a-button>
        <a-button type="primary" @click="resetPagination">查询</a-button>
      </div>
    </div>
  </div>
</template>
<script>
import { inject, toRefs, reactive } from 'vue'
export default {
  setup() {
    const state = reactive({
      open: false
    })
    return {
      ...toRefs(state),
      ...toRefs(inject('initState'))
    }
  }
}
</script>
<style scoped>
.filter {
  background: #ffffff;
}

.filterContainer {
  display: flex;
  flex-direction: row;
}

.filter .title {
  display: inline-block;
}
</style>
